import React, { useEffect, useState } from 'react';
import AppContext from '../AppContext';
import {BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import App from "../App";
import Service from '../service';
import WebDevelopment from  '../Services/WebDevelopment';
import GameDevelopment from '../Services/GameDevelopment';
import MobileDevelopment from '../Services/MobileDevelopment';
import ServiceDetails from '../Services/Service_details';
import About from '../about.js';
import Contact from '../contect.js';
import NewServices from '../New_services/Service_details';
import Career from '../Career/career';
import CareerDetail from '../Career/CareerDetail';
import Bhabhioffline from '../over_games/Bhabhiofline';
import Bluffofline from '../over_games/bluffofline';
import Callbreak from '../over_games/callbreak';
import Ginrummy from '../over_games/Ginrummy';
import Hazari from  '../over_games/Hazari';
import Kachuful from '../over_games/kachuful';
import Rummy500 from  '../over_games/rummy500';
import Rummy from '../over_games/rummy';
import Ludo from  '../over_games/ludo';
import Solitaire from '../over_games/solitaire';
import G2829 from '../over_games/2829';
import SpadesMultiplayer  from '../over_games/SpadesMultiplayer';
import Tank from '../over_games/TunkMultiplayer'; 
import Carrom from '../over_games/Carrom';
import Blog from '../Blog/Blog';
import Privacy from '../privacypolicy.js';
import Terms from '../Termsandcondition';
import BlogDetails from '../Blog/BlogDetails';
import Nodepage from '../Services/Nodejs';
import Reactpage from '../Services/React';
import Expresspage from '../Services/Express';
import Flutterpage from '../Services/Flutter';
import PHPpage from '../Services/Php';
import Codelgnitorpage from '../Services/Codelgnitor';
import Unitypage from '../Services/Game_development/unity';
import Androidpage from '../Services/Game_development/Android';
import Webbased from '../Services/Game_development/WebBasedGamedevelopment';
import IOSPage from '../Services/Game_development/IOS';
import Newrummy from '../over_games/new_rummy';
import CardGame from '../Services/Game_development/CardGame';
import Casino from '../Services/Game_development/Casino';
import Board from '../Services/Game_development/Board';
import Puzzle from '../Services/Game_development/Puzzle/puzzle';
import Arcarde from '../Services/Game_development/Arcarde/Arcarde';
import Action from '../Services/Game_development/Action/Action';
import Adventure from '../Services/Game_development/Adventure/Adventure';
import Racing from '../Services/Game_development/Racing/Racing';
import Casual from '../Services/Game_development/Casual/Casual';
import Educational from '../Services/Game_development/Educational/Educational';
import Horror from '../Services/Game_development/Horror/Horror';  
import Music from '../Services/Game_development/Music/Music.js';
import Quiz from '../Services/Game_development/Quiz/Quiz';
import Roboclick from '../Services/Game_development/Roguclikc/Roguclikc';
import RPG from '../Services/Game_development/RPG/Rpg';
import Sendbox from '../Services/Game_development/Sandbox/Sandbox';
import Simulator from '../Services/Game_development/Simulator/Simulator';
import Sport from '../Services/Game_development/Sport/Sport';
import Strategy from '../Services/Game_development/Strategy/Strategy';
import Word from '../Services/Game_development/Word/Word';
import Mobiledevelopmentold from '../Services/Old_mobiledevelopment';
import MultiplayerGames from '../Services/Game_development/MultiplayerGames';
import MobilePcConsoleGames from '../Services/Game_development/MobilePcConsoleGames';
import ArVrGames from '../Services/Game_development/ArVrGames';
import AndroidAppDevelopment from '../Services/AndroidAppDevelopment';
import IosAppDevelopment from '../Services/IosAppDevelopment';
import CrossPlatformApps from '../Services/CrossPlatformApps';
import MobileUI from '../Services/MobileUI';
import GameUI from '../Services/GameUI';
import Wireframes from '../Services/Wireframes';
import Prototyping from '../Services/Prototyping';
import BusinessWebsites from '../Services/BusinessWebsites';
import WebApplications from '../Services/WebApplications';
import AdminPanelsDashboards from '../Services/AdminPanelsDashboards';
import FunctionalTesting from '../Services/FunctionalTesting';
import BugFixing from '../Services/BugFixing';
import {
  GameApiDevelopment,
  GameServerDevelopment,
  MultiplayerBackendDevelopment,
  GameDatabaseDesign,
  GameCloudDeployment,
  GameDevOpsServices
} from '../Services/BackendCloudPages';
import {
  CharacterAnimation,
  CreatureAnimation,
  RiggingSkinning,
  FacialAnimation,
  MotionCaptureCleanup,
  GameCinematics,
  ProductAnimations
} from '../Services/Animation3DPages';
import {
  CharacterModeling,
  EnvironmentModeling,
  PropsWeaponsModeling,
  VehicleModeling,
  ArchitecturalModeling,
  LowHighPolyAssets,
  PbrTexturing,
  UvMapping,
  BlenderSculpting
} from '../Services/Modeling3DPages';
import {
  CharacterDesign,
  ConceptArt,
  GameIllustrations,
  SpriteAnimation,
  SpineAnimation,
  GameUiAssets
} from '../Services/Art2DPages';
import {
  GameParticleEffects,
  GameShaderDevelopment,
  GameLighting,
  GameArtOptimization
} from '../Services/VfxTechnicalPages';
import {
  GameMaintenance,
  GameContentUpdates,
  GameAnalytics,
  GameMonetization,
  GameAdIntegration,
  GameStorePublishing
} from '../Services/LiveOpsPages';
import TonkMultiplayerLanding from '../gamewebpages/TonkMultiplayerLanding';

const RouteLoader = ({ loading }) => {
  const location = useLocation();
  const [routeLoading, setRouteLoading] = useState(false);

  useEffect(() => {
    setRouteLoading(true);
    const loaderTimer = setTimeout(() => {
      setRouteLoading(false);
    }, 550);

    return () => clearTimeout(loaderTimer);
  }, [location.pathname]);

  if (!loading && !routeLoading) {
    return null;
  }

  return (
    <div className="page-loader route-page-loader" role="status" aria-live="polite" aria-busy="true">
      <div className="loader-backdrop" />
      <div className="loader-card">
        <div className="loader-logo-wrap">
          <img className="loader-logo" src="/assets/img/white-logo.png" alt="Oengines" />
        </div>
        <div className="loader-orbit" aria-hidden="true">
          <span className="loader-core" />
          <span className="loader-ring ring-1" />
          <span className="loader-ring ring-2" />
          <span className="loader-ring ring-3" />
        </div>
        <div className="loader-text">
          <span className="loader-brand">Loading</span>
          <span className="loader-sub">Preparing your experience</span>
        </div>
        <div className="loader-bars">
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
};

class AppRouter extends React.Component {
   
  state = {
    apiHeaderData: null,
    apiCareerData: null,
    loading : true
  };

  componentDidMount() {
      Promise.allSettled([
        fetch('/headers/Main').then((res) => res.json()),
        fetch('/careers').then((res) => res.json()),
      ])
        .then(([headerResult, careerResult]) => {
          const headerData = headerResult.status === 'fulfilled' ? headerResult.value : [];
          const careerData = careerResult.status === 'fulfilled' ? careerResult.value : [];

          if (headerResult.status === 'rejected') {
            console.error('Header API Error:', headerResult.reason);
          }

          if (careerResult.status === 'rejected') {
            console.error('Career API Error:', careerResult.reason);
          }

          this.setState({
            apiHeaderData: headerData,
            apiCareerData: careerData,
            loading: false,
          });
        })
        .catch((err) => {
          console.error('API Error:', err);
          this.setState({ loading: false });
        });

      ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Page" });
      
  }

    render() { 

      const contextValue = {
        apiHeaderData: this.state.apiHeaderData,
        apiCareerData: this.state.apiCareerData,
        loading: this.state.loading,
      };
      
      return (  
        <AppContext.Provider value={contextValue}>
          <BrowserRouter>    
            <RouteLoader loading={this.state.loading} />
            
            <Routes>

              <Route exact path="/" element={<App />} />
              <Route path='/29card' element={<G2829/>} />
              <Route path="/Service" element={<Service />} />
              <Route path="/mobiledevelopment" element={<MobileDevelopment />} />
              <Route path="/old_mobiledevelopment" element={<Mobiledevelopmentold />} />
              <Route path="/webdevelopment" element={<WebDevelopment />} />
              <Route path="/business-websites" element={<BusinessWebsites />} />
              <Route path="/business-website-development" element={<BusinessWebsites />} />
              <Route path="/web-applications" element={<WebApplications />} />
              <Route path="/gaming-web-application-development" element={<WebApplications />} />
              <Route path="/admin-panels-dashboards" element={<AdminPanelsDashboards />} />
              <Route path="/gaming-admin-panel-development" element={<AdminPanelsDashboards />} />
              <Route path="/game-functional-testing" element={<FunctionalTesting />} />
              <Route path="/functional-testing" element={<FunctionalTesting />} />
              <Route path="/game-bug-fixing" element={<BugFixing />} />
              <Route path="/bug-fixing" element={<BugFixing />} />
              <Route path="/game-api-development" element={<GameApiDevelopment />} />
              <Route path="/game-server-development" element={<GameServerDevelopment />} />
              <Route path="/multiplayer-backend-development" element={<MultiplayerBackendDevelopment />} />
              <Route path="/game-database-design" element={<GameDatabaseDesign />} />
              <Route path="/game-cloud-deployment" element={<GameCloudDeployment />} />
              <Route path="/game-devops-services" element={<GameDevOpsServices />} />
              <Route path="/character-animation" element={<CharacterAnimation />} />
              <Route path="/creature-animation" element={<CreatureAnimation />} />
              <Route path="/rigging-skinning" element={<RiggingSkinning />} />
              <Route path="/facial-animation" element={<FacialAnimation />} />
              <Route path="/motion-capture-cleanup" element={<MotionCaptureCleanup />} />
              <Route path="/game-cinematics" element={<GameCinematics />} />
              <Route path="/product-animations" element={<ProductAnimations />} />
              <Route path="/character-modeling" element={<CharacterModeling />} />
              <Route path="/environment-modeling" element={<EnvironmentModeling />} />
              <Route path="/props-weapons-modeling" element={<PropsWeaponsModeling />} />
              <Route path="/vehicle-modeling" element={<VehicleModeling />} />
              <Route path="/architectural-modeling" element={<ArchitecturalModeling />} />
              <Route path="/low-poly-high-poly-assets" element={<LowHighPolyAssets />} />
              <Route path="/pbr-texturing" element={<PbrTexturing />} />
              <Route path="/uv-mapping" element={<UvMapping />} />
              <Route path="/blender-sculpting" element={<BlenderSculpting />} />
              <Route path="/game-character-design" element={<CharacterDesign />} />
              <Route path="/game-concept-art" element={<ConceptArt />} />
              <Route path="/game-illustrations" element={<GameIllustrations />} />
              <Route path="/sprite-animation" element={<SpriteAnimation />} />
              <Route path="/spine-animation" element={<SpineAnimation />} />
              <Route path="/game-ui-assets" element={<GameUiAssets />} />
              <Route path="/game-particle-effects" element={<GameParticleEffects />} />
              <Route path="/game-shader-development" element={<GameShaderDevelopment />} />
              <Route path="/game-lighting" element={<GameLighting />} />
              <Route path="/game-art-optimization" element={<GameArtOptimization />} />
              <Route path="/game-maintenance" element={<GameMaintenance />} />
              <Route path="/game-content-updates" element={<GameContentUpdates />} />
              <Route path="/game-analytics" element={<GameAnalytics />} />
              <Route path="/game-monetization" element={<GameMonetization />} />
              <Route path="/game-ad-integration" element={<GameAdIntegration />} />
              <Route path="/game-store-publishing" element={<GameStorePublishing />} />
              <Route path="/gamedevelopment" element={<GameDevelopment />} />
              <Route path="/multiplayer-games" element={<MultiplayerGames />} />
              <Route path="/multiplayer-game-development" element={<MultiplayerGames />} />
              <Route path="/mobile-pc-console-games" element={<MobilePcConsoleGames />} />
              <Route path="/mobile-pc-web-console-game-development" element={<MobilePcConsoleGames />} />
              <Route path="/ar-vr-games" element={<ArVrGames />} />
              <Route path="/ar-vr-game-development" element={<ArVrGames />} />
              <Route path="/android-app-development" element={<AndroidAppDevelopment />} />
              <Route path="/android-application-development" element={<AndroidAppDevelopment />} />
              <Route path="/ios-app-development" element={<IosAppDevelopment />} />
              <Route path="/ios-application-development" element={<IosAppDevelopment />} />
              <Route path="/cross-platform-apps" element={<CrossPlatformApps />} />
              <Route path="/cross-platform-app-development" element={<CrossPlatformApps />} />
              <Route path="/mobile-ui-design" element={<MobileUI />} />
              <Route path="/mobile-game-ui-design" element={<MobileUI />} />
              <Route path="/game-ui-design" element={<GameUI />} />
              <Route path="/game-ux-ui-design" element={<GameUI />} />
              <Route path="/game-wireframes" element={<Wireframes />} />
              <Route path="/wireframe-design" element={<Wireframes />} />
              <Route path="/game-prototyping" element={<Prototyping />} />
              <Route path="/game-ui-prototyping" element={<Prototyping />} />
              <Route path="/ServiceDetails" element={<ServiceDetails />} />
              <Route path="/unity" element={<Unitypage />} />
              <Route path="/android" element={<Androidpage />} />
              <Route path="/webbased" element={<Webbased />} />
              <Route path="/ios" element={<IOSPage />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/blog" element={<Blog />} />            
              <Route path="/blogdetails" element={<BlogDetails />} />
              <Route path="/Newservice" element={<NewServices />} />          
              <Route path="/career" element={<Career />} />            
              <Route path="/career/:slug" element={<CareerDetail />} />
              <Route path="/careerdetail" element={<CareerDetail />} />
              <Route path="/careerdetail/:id" element={<CareerDetail />} />
              <Route exact path="/home/privacy" element={<Privacy />}  />
              <Route path="/terms" element={<Terms />} />
              <Route path="/nodejs" element={<Nodepage />} />
              <Route path="/reactjs" element={<Reactpage />} />
              <Route path="/expressjs" element={<Expresspage />} />
              <Route path="/flutter" element={<Flutterpage />} />
              <Route path="/php" element={<PHPpage />} />
              <Route path="/codelgnitor" element={<Codelgnitorpage />} />            
              <Route path="/bhabhi_card_game" element={<Bhabhioffline />} />
              <Route path="/bluff_card_game" element={<Bluffofline />} />
              <Route path="/callbreak" element={<Callbreak />} />
              <Route path="/gin_rummy" element={<Ginrummy />} />
              <Route path="/hazari_card_game" element={<Hazari />} />
              <Route path="/kachufulJudgement" element={<Kachuful />} />
              <Route path="/rummy500" element={<Rummy500 />} />
              <Route path="/rummy" element={<Rummy />} />
              <Route path="/rummy_multiplayer" element={<Newrummy />} />
              <Route path="/ludo" element={<Ludo />} />
              <Route path="/solitaire" element={<Solitaire />} /> 
              <Route path="/spades_multiplayer" element={<SpadesMultiplayer />} /> 
              <Route path="/tonk" element={<Tank />} /> 
              <Route path="/tonk-multiplayer" element={<TonkMultiplayerLanding />} />
              <Route path="/carrom" element={<Carrom />} /> 
              <Route path="/Card" element={<CardGame />} />
              <Route path="/Casino" element={<Casino />} /> 
              <Route path="/Board" element={<Board />} /> 
              <Route path="/Puzzle" element={<Puzzle />} /> 
              <Route path="/Arcarde" element={<Arcarde />} /> 
              <Route path="/Action" element={<Action />} /> 
              <Route path="/Adventure" element={<Adventure />} /> 
              <Route path="/Racing" element={<Racing />} /> 
              <Route path="/Casual" element={<Casual/>} />
              <Route path="/Educational" element={<Educational/>} />
              <Route path="/Horror" element={<Horror/>} />
              <Route path="/Music" element={<Music/>} />
              <Route path="/Quiz" element={<Quiz/>} />
              <Route path="/Roguelike" element={<Roboclick/>} />
              <Route path="/Rpg" element={<RPG/>} />
              <Route path="/sendbox" element={<Sendbox/>} />
              <Route path="/Simulator" element={<Simulator/>} />
              <Route path="/Sport" element={<Sport/>} />
              <Route path="/Strategy" element={<Strategy/>} />
              <Route path="/Word" element={<Word/>} />
            </Routes>

      </BrowserRouter>
    </AppContext.Provider>
      )
    }
  }

export default AppRouter;
